<template>
  <div class="bg">
    <div class="content">
      <el-card>
        <el-form
          :model="form"
          status-icon
          label-width="auto"
          :inline-message="true"
          label-position="left"
        >
          <el-form-item label="人员姓名：">
            <el-input
              type="textarea"
              v-model="name"
              maxlength="500"
              show-word-limit
              :disabled="true"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="进场时间：" prop="startTime">
            <div @click="showTimePopup = true">
              <i class="iconfont icon-riqi" />
              &nbsp;&nbsp;
              {{ time }}
            </div>
            <van-popup
              v-model="showTimePopup"
              round
              readonly="readonly"
              position="bottom"
              :style="{
                height: 45,
              }"
            >
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="请选择退场时间"
                :min-date="minDate"
                :max-date="maxDate"
                :overlay="true"
                @confirm="confirmTime"
                @cancel="showTimePopup = false"
              />
            </van-popup>
          </el-form-item>
        </el-form>
        <div style="text-align: right">
          <el-button size="mini" type="info" @click="back">返回</el-button>
          <el-button size="mini" type="primary" @click="submitForm">提交</el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { filtration$ } from "@/utils/admin";
import { postDetail, postEntryOrExit, postDistributionTemplate } from "@/api/app/roster";
export default {
  data() {
    return {
      name: "",
      form: {},
      templateForm: {
        type: 3,
      },
      // 时间选择器
      time: "请选择进场时间",
      showTimePopup: false,
      minDate: new Date(new Date().getFullYear() - 2, 1, 1),
      maxDate: new Date(new Date().getFullYear() + 2, 1, 1),
      currentDate: new Date(),
    };
  },
  created() {
    this.getTime();
    this.name = this.$store.state.app.content.toString();
    if (this.$route.params.oneOrMore == 1) {
      this.detail();
    }
  },
  methods: {
    // 人员姓名
    detail() {
      postDetail(JSON.stringify(this.$store.state.app.itemId)).then((res) => {
        this.name = res.data.name;
      });
    },
    // 默认进场时间
    getTime() {
      let month = "";
      if (new Date().getMonth() < 10) {
        month = "0" + (new Date().getMonth() + 1);
      }
      let day = "";
      if (new Date().getDate() < 10) {
        day = "0" +new Date().getDate();
      }
      this.time = new Date().getFullYear() + "-" + month + "-" + day;
      this.form.time = this.time;
    },
    // 时间选择
    confirmTime(value) {
      let date = this.datePick.datePick(value).substring(0, 10);
      this.time = date;
      this.form.time = date;
      this.showTimePopup = false;
    },
    // 提交表单
    submitForm() {
      if (this.$route.params.oneOrMore == 1) {
        this.form.ids = [this.$store.state.app.itemId];
      } else if (this.$route.params.oneOrMore == 2) {
        this.form.ids = this.$store.state.app.itemId;
      }
      this.form.status = 2;
      this.form.projectId = this.$store.state.app.projectId;
      postEntryOrExit(filtration$(this.form))
        .then((res) => {
          if (res.code == 200) {
            this.templateForm.projectId = this.$store.state.app.projectId;
            this.templateForm.ids = this.form.ids;
            postDistributionTemplate(filtration$(this.templateForm)).then((res) => {});
            this.$notify({ type: "success", message: "退场成功！" });
            this.$router.back();
          }
        })
        .catch((error) => {
          this.$store.dispatch("submitToken");
        });
    },
    // 取消按钮
    back() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  padding: 10px;
  min-height: 100vh;
  margin-bottom: 60px;
  background-color: #f0f0f0;
}
.content {
  span {
    font-size: 14px;
  }
  .el-card {
    margin-bottom: 10px;
    .iconfont {
      color: #b2bec3;
    }
    /deep/ .el-card__body {
      padding: 15px;
    }
    /deep/ .el-form-item {
      margin-bottom: 0px;
      .el-form-item__label {
        color: #000;
      }
      .el-input__inner {
        border: unset;
        padding: 0;
      }
    }
  }
}
</style>
